import { Link } from "react-router-dom";

function BlogCard({ blog }) {
  return (
    <div className="blog-card">
      <img
        src={blog.coverImageUrl}
        alt={blog.title}
        loading="lazy"
      />
      <div className="blog-card-body">
        <h3>{blog.title}</h3>
        <p>{blog.excerpt}</p>
        <Link to={`/blog/${blog.slug}`} className="secondary-btn">
          Read More
        </Link>
      </div>
    </div>
  );
}

export default BlogCard;
